import { connect } from 'react-redux'
import { SelectboxProps, Selectbox } from 'view/components/options'
import { createStructuredSelector } from 'reselect'
import { ReferenceRate, EntityType, RepoType } from 'api'
import { Field } from 'view/components/inputs'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { ReferenceRateHelper, RepoTypeHelper } from 'model'

/* Reference Rate */

export interface ReferenceRateSelectboxOwnProps {
  referenceRateIds?: string[] | null | undefined
}

export interface ReferenceRateSelectboxProps extends ReferenceRateSelectboxOwnProps, SelectboxProps<ReferenceRate, string> {
  referenceRateIds?: string[]
}

const referenceRateMapStateToProps = createStructuredSelector({
  optionKeys: (_: {}, props: ReferenceRateSelectboxOwnProps): string[] => props.referenceRateIds ?? [],
  getOption: createEntityGetterSelector(EntityType.REFERENCE_RATE)
})

export const ReferenceRateSelectbox = connect(referenceRateMapStateToProps, null, null, { forwardRef: true })(
  Selectbox as React.ComponentType<ReferenceRateSelectboxProps>
)

ReferenceRateSelectbox.defaultProps = {
  getOptionText: ReferenceRateHelper.getName,
  canClear: true
}

export const ReferenceRateSelectboxField = Field(ReferenceRateSelectbox)

/* RepoType */

export interface RepoTypeSelectboxOwnProps {
  supportedRepoTypes?: RepoType[] | null | undefined
}
export interface RepoTypeSelectboxProps extends RepoTypeSelectboxOwnProps, SelectboxProps<RepoType, RepoType> {
  supportedRepoTypes?: RepoType[]
}

const repoTypeMapStateToProps = createStructuredSelector({
  optionKeys: (_: {}, props: RepoTypeSelectboxOwnProps): RepoType[] => props.supportedRepoTypes ?? []
})

export const RepoTypeSelectbox = connect(repoTypeMapStateToProps, null, null, { forwardRef: true })(
  Selectbox as React.ComponentType<RepoTypeSelectboxProps>
)

RepoTypeSelectbox.defaultProps = {
  getOptionText: RepoTypeHelper.getName
}

export const RepoTypeSelectboxField = Field(RepoTypeSelectbox)
